import React, { useContext, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';

import { PROFILE_ROUTE, FAVOURITES_ROUTE } from '../../../utils/consts';
import { Context } from "../../../index";

import RegistrationForm from '../../modals/UserForms/RegistrationForm/RegistrationForm';
import ModalPortal from "../../../utils/ModalPortal";
import { reachGoal } from "../../../utils/metrika/metrika";

import chatIcon from "../../../Assets/BottomMenu/chatIcon.svg";
import profilePlaceholder from '../../../Assets/profile.svg';
import Favourites from '../../../Assets/hearts/heart-black.svg';

import styles from './UserMiniProfile.module.css';

import {
    getMessagesTargetRoute,
    isMessagesRoute,
    formatMessagesBadge
} from "../../../utils/chat/messagesNavigation";

const UserMiniProfile = observer(() => {
    const { user, messages } = useContext(Context);

    const history = useHistory();
    const location = useLocation();

    const totalUnreadCount = messages.totalUnreadCount;
    const isChatPage = isMessagesRoute(location.pathname);
    const isFavouritesPage = location.pathname.startsWith(FAVOURITES_ROUTE);

    const [showRegistrationModal, setShowRegistrationModal] = useState(false);

    const getProfileImageUrl = () => {
        if (!user.UserData || !user.UserData.id || !user.UserData.img) {
            return null;
        }

        const userId = user.UserData.id;
        const userImg = user.UserData.img;

        if (userImg === 'EMPTY') {
            return null;
        }

        if (typeof userImg === 'string') {
            return `${process.env.REACT_APP_API_URL}users/user${userId}/${userImg}`;
        }

        return null;
    };

    const profileImageUrl = getProfileImageUrl();

    const handleFavoritesClick = (e) => {
        e.stopPropagation();

        if (user.isAuth && user.UserData?.id) {
            history.push(FAVOURITES_ROUTE);
            reachGoal("history.push(FAVOURITES_ROUTE) NAVIGATION");
            return;
        }

        setShowRegistrationModal(true);
    };

    const handleChatClick = () => {
        history.push(getMessagesTargetRoute());
        reachGoal("history.push(MESSAGES_ROUTE) NAVIGATION");
    };

    const handleProfileClick = () => {
        history.push(`${PROFILE_ROUTE}/${user.UserData.id}`);
        reachGoal("history.push(`${PROFILE_ROUTE} NAVIGATION`)");
    };

    if (!user.isAuth || !user.UserData) {
        return (
            <div className={styles.navContainer}>
                <button
                    type="button"
                    className={styles.loginButton}
                    onClick={() => setShowRegistrationModal(true)}
                >
                    Войти
                </button>

                <ModalPortal>
                    <RegistrationForm
                        show={showRegistrationModal}
                        onHide={() => setShowRegistrationModal(false)}
                    />
                </ModalPortal>
            </div>
        );
    }

    return (
        <div className={styles.navContainer}>
            <button
                type="button"
                className={`${styles.navIconButton} ${styles.chatButton} ${isChatPage ? styles.navIconButtonActive : ''}`}
                onClick={handleChatClick}
                title="Сообщения"
                aria-label="Сообщения"
            >
                <img
                    src={chatIcon}
                    alt=""
                    className={`${styles.navIcon} ${styles.chatIcon}`}
                />

                {totalUnreadCount > 0 && (
                    <div className={styles.badge}>
                        {formatMessagesBadge(totalUnreadCount)}
                    </div>
                )}
            </button>

            <button
                type="button"
                className={`${styles.navIconButton} ${styles.favoriteButton} ${isFavouritesPage ? styles.navIconButtonActive : ''}`}
                onClick={handleFavoritesClick}
                title="Избранное"
                aria-label="Избранное"
            >
                <img
                    src={Favourites}
                    alt=""
                    className={`${styles.navIcon} ${styles.favoriteIcon}`}
                />
            </button>

            <button
                type="button"
                className={styles.profileButton}
                onClick={handleProfileClick}
                title={user.UserData?.nickname || 'Профиль'}
                aria-label="Открыть профиль"
            >
                <div className={styles.profileAvatarContainer}>
                    {profileImageUrl ? (
                        <img
                            src={profileImageUrl}
                            alt="Аватар"
                            className={styles.profileAvatarImg}
                        />
                    ) : (
                        <img
                            src={profilePlaceholder}
                            alt="Профиль"
                            className={styles.profileAvatarImg}
                        />
                    )}
                </div>

                <span className={styles.profileNickname}>
                    {user.UserData?.nickname || 'Пользователь'}
                </span>
            </button>

            <ModalPortal>
                <RegistrationForm
                    show={showRegistrationModal}
                    onHide={() => setShowRegistrationModal(false)}
                />
            </ModalPortal>
        </div>
    );
});

export default UserMiniProfile;